import styled from 'styled-components';
import { ReactComponent as Delete } from '@/assets/images/order/delete.svg';
import SelectComponent from '@/components/SelectComponent';
import theme from '@/styles/theme';
import DNBoxInput from '@/components/DNBoxInput';
import useUpdateOrderPriceFormViewModel from '@/hooks/order/useUpdateOrderPriceFormViewModel';

interface Props {
  orderId: number;
  onCloseModal: () => void;
}

const UpdateOrderPriceModal = ({
  orderId,
  onCloseModal
}: Props) => {
  const viewModel = useUpdateOrderPriceFormViewModel({
    orderId,
    onCloseModal
  });
  return (
    <Wrapper
      onMouseMove={e => {
        e.stopPropagation();
      }}>
      <TitleRow>
        <Title>결제 금액 변경</Title>
        <Delete
          style={{ cursor: 'pointer' }}
          onClick={onCloseModal}
        />
      </TitleRow>
      <Col>
        <SubTitle>변경 사유</SubTitle>
        {viewModel.selectOptions && (
          <SelectComponent
            isSearchable={false}
            selectStyle={{
              width: '100%',
              marginBottom: 6,
              borderRadius: 12,
              padding: 5,
              height: 60,
              background: theme.DF_COLOR.GRAY10,
              border: `1px solid ${theme.DF_COLOR.GRAY50}`,
              fontSize: 18
            }}
            indicatorStyle={{ display: 'none' }}
            options={viewModel.selectOptions}
            defaultValue={viewModel.selectOptions[0]}
            onChange={viewModel.changeReason}
          />
        )}
        {viewModel.isManualReasonSelected() && (
          <DNBoxInput
            maxLength={255}
            style={{ height: 60, width: '100%' }}
            value={viewModel.form.reason}
            onChange={e =>
              viewModel.onChangeInputReason(
                (e.target as HTMLInputElement).value
              )
            }
            onClear={viewModel.onClearReason}
          />
        )}
      </Col>
      <SubTitle>변경 금액</SubTitle>
      <DNBoxInput
        maxLength={20}
        onChange={e =>
          viewModel.onChangeInputPrice((e.target as HTMLInputElement).value)
        }
        value={viewModel.form.price}
        type="number"
        style={{ height: 60, width: '100%' }}
      />
      <Button onClick={viewModel.onSubmit}>변경</Button>
    </Wrapper>
  );
};

export default UpdateOrderPriceModal;

const Wrapper = styled.div``;

const TitleRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const Title = styled.span`
  ${({ theme }) => theme.DF_TYPOGRAPHY.UI24SB};
`;

const SubTitle = styled.div`
  ${({ theme }) => theme.DF_TYPOGRAPHY.UI14M};
  color: ${({ theme }) => theme.DF_COLOR.GRAY600};
  margin-top: 20px;
  margin-bottom: 6px;
`;

const Button = styled.div`
  border-radius: 12px;
  padding: 17px 0;
  width: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: ${({ theme }) => theme.DF_COLOR.PRIMARY500};
  color: ${({ theme }) => theme.DF_COLOR.WHITE};
  ${({ theme }) => theme.DF_TYPOGRAPHY.UI18SB};
  margin-top: 32px;
  margin-left: auto;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

const Col = styled.div`
  display: flex;
  flex-direction: column;
  width: 432px;
`;
